import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container, Row } from 'reactstrap';

// import images
import CarouselPage from './CarouselPage';

// import components
import IButtonComponent from '../../components/Common/iComponents/iButton/IButton';
import { useDispatch, useSelector } from 'react-redux';

//import sagas
import {
  getUserEmail,
  setNewPasswordRequest,
  updatePasswordUsers,
} from '../../store/actions';

import { useHistory } from 'react-router-dom';
import getUrlParams from '../../components/Common/getUrlParams/getUrlParams';

const RecoverPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { url, brand } = getUrlParams({ name: 'nwkID' });

  const search = window.location.search;

  const params = new URLSearchParams(search);
  const email = params.get('email');
  const key = params.get('key');

  const { users, success, message, loading, loadingUpdate, successUpdate } =
    useSelector((state: any) => state.Users);

  const [state, setState] = useState({
    valid: false,
    email: '',
    validEmail: true,
    validSecondPassword: false,
    password: '',
    secondPassword: '',
  });

  useEffect(() => {
    if (email && key) {
      dispatch(getUserEmail({ email, key }));
    }
  }, [email, key]);

  useEffect(() => {
    if (users) {
      setState({ ...state, valid: users?.USUARIO_TOKEN === key });
    }
  }, [users]);

  useEffect(() => {
    setState({
      ...state,
      validSecondPassword: state.password === state.secondPassword,
    });
  }, [state.secondPassword]);

  function validarCorreoElectronico(correo: any) {
    const expresion = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return expresion.test(correo);
  }

  const passwordTemplate = () => {
    return (
      <>
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            value={state.password}
            type="password"
            className="form-control"
            onChange={(e) => {
              setState({ ...state, password: e.target.value });
            }}
          />
          <label className="form-label pt-2">Repeat new password</label>
          <input
            value={state.secondPassword}
            type="password"
            className="form-control"
            onChange={(e) => {
              setState({ ...state, secondPassword: e.target.value });
            }}
          />
        </div>
        {!state.validSecondPassword ? (
          <label className="form-label" style={{ color: 'red' }}>
            The passwords do not match.
          </label>
        ) : null}
        <div className="mb-3 mt-4">
          <IButtonComponent
            actionOnClick={(e: any) => {
              changePasswordHanlder();
            }}
            className={'w-100 button waves-light'}
            label={'Change Password'}
          />
        </div>
        {loadingUpdate ? LoadingIndicator() : null}
      </>
    );
  };

  const setRequestTemplate = () => {
    return (
      <>
        <div className="mb-3">
          <label className="form-label">Email*</label>
          <input
            style={{ border: state.validEmail ? '' : 'solid 1px red' }}
            value={state.email}
            onChange={(e) => {
              setState({ ...state, validEmail: true, email: e.target.value });
            }}
            type="text"
            className="form-control"
            id="email"
            placeholder="Enter email"
          />
        </div>
        {!state.validEmail ? (
          <label className="form-label" style={{ color: 'red' }}>
            Invalid email address
          </label>
        ) : null}
        <div className="mb-3 mt-4">
          <IButtonComponent
            actionOnClick={(e: any) => {
              newRequestHanlder();
            }}
            className={'w-100 button waves-light'}
            label={success ? 'Resend Email' : 'Send request'}
          />
        </div>
        {loading ? LoadingIndicator() : null}
      </>
    );
  };

  const LoadingIndicator = () => {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  };

  const newRequestHanlder = () => {
    const validEmail = validarCorreoElectronico(state.email);
    if (validEmail) {
      dispatch(
        setNewPasswordRequest({
          email: state.email,
          url: window.location.href,
        }),
      );
    } else {
      setState({ ...state, validEmail });
    }
  };

  const changePasswordHanlder = () => {
    if (state.validSecondPassword) {
      dispatch(
        updatePasswordUsers({
          users: { ...users, USUARIO_PASSWORD: state.password },
        }),
      );
    }
  };

  return (
    <React.Fragment>
      <PageTitle>
        <title>Reset Password | {brand.name}</title>
      </PageTitle>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to={url} className="d-block auth-logo">
                        <img src={brand.logo} alt="" height="60" />{' '}
                      </Link>
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Reset Password</h5>
                        <p className="text-muted mt-2">
                          Reset Password with {brand.name}.
                        </p>
                      </div>
                      <div
                        className="alert alert-success text-center mb-4 mt-4 pt-2"
                        role="alert"
                      >
                        {email && key
                          ? state.valid
                            ? 'Successful request'
                            : 'Expired code'
                          : message
                            ? message
                            : 'Enter your Email and instructions will be sent to you! '}
                      </div>

                      {successUpdate ? null : email && key ? (
                        state.valid ? (
                          passwordTemplate()
                        ) : (
                          <div className="mb-3 mt-4">
                            <IButtonComponent
                              actionOnClick={(e: any) => {
                                history.push('/auth-recoverpw');
                              }}
                              className={'w-100 button waves-light'}
                              label={'Resend request'}
                            />
                          </div>
                        )
                      ) : (
                        setRequestTemplate()
                      )}

                      <div className="mt-5 text-center">
                        <p className="text-muted mb-0">
                          Remember It ?{' '}
                          <Link
                            to={'/login' + url}
                            className="text-primary fw-semibold"
                          >
                            {' '}
                            Sign In{' '}
                          </Link>{' '}
                        </p>
                      </div>
                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} {brand.name}.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RecoverPassword;
